import React from 'react';
import PropTypes from 'prop-types';

import Grid from 'material-ui/Grid';
import Button from '../../common/Button';

export class EditFormActions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      applyMirror: false
    };
  }

  handleMirrorToggle() {
    const { applyMirror } = this.state;
    this.setState({
      applyMirror: !applyMirror
    });

    this.setState()
  }
  
  render() {
    const { onCancel, canSubmit } = this.props;
    const disableSubmit = !canSubmit;

    return (
      <Grid container>
        <Grid item xs={12}>
          <Grid container justify="flex-end">
            <Button
              default
              type="button"
              variant="raised"
              onClick={onCancel}
              label="Cancel"
            />
            <Button
              primary
              type="submit"
              variant="raised"
              label="Submit"
              disabled={disableSubmit}
            />
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

EditFormActions.propTypes = {
  canSubmit: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default EditFormActions;


// WEBPACK FOOTER //
// ./src/components/StackupDesign/Settings/Actions.js